import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import DocumentGrid from '../../../features/common/document-grid/components/DocumentGrid';

export default function DocumentLibraryPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Document Library')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<DocumentGrid />
			</div>
		</React.Fragment>
	)
} 
